import React from 'react';
import { Layout } from 'antd';
import { CompareWrapper } from '@components/compare-panel';
import { useParams } from 'react-router-dom';

const CustomDashboard = ({ isSharing = false }) => {
  const { id } = useParams();

  return (
    <>
      <Layout.Content className="container">
        <CompareWrapper isSharing={isSharing} id={id} />
      </Layout.Content>
    </>
  );
};

export default CustomDashboard;
